import { CLINIC_APIS } from "@/api_framework/api_config";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { setWareHouseList } from "@/app_redux/reducers/slices/auth/configuration_slice";

import { IClinicDestailsResponse, IClinicDestailsResponseData } from "@/api_framework/api_modals/Clinics";

AxiosCurlirize(axios, () => {});
export const useClinicDetailsAPI = () => {
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const configuration = useConfiguration();
  const [clinicAddess, setClinicAddess] = useState<IClinicDestailsResponseData>(null);
  const execute = useCallback(
    async (clinicId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${CLINIC_APIS?.CLINIC_DETAILS_API?.baseURL}?clinic_id=${clinicId}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IClinicDestailsResponse>) => {
            if (res.data.status === true) {
              setClinicAddess(res.data.data);
            } else {
              setClinicAddess(null);
            }
          })
          .catch((e: AxiosError) => {
            setClinicAddess(null);

            sendCurl(e.config["curlCommand"]);
            if (e.code === "ERR_BAD_REQUEST") {
              //   toast.error("Error while fetching List details");
            }
            if (e.status === 400) {
              //   toast("Product records not found");
            }

            if (e.response.status === 500) {
              toast.error("Server error 500");
            }
          });
      } catch (e: any) {
        setClinicAddess(null);
        toast.error("Server Error: " + e.message);
        dispatch(setWareHouseList({ data: [] }));
      }
    },
    [dispatch],
  );
  return { execute, clinicAddess };
};
